/* Bloombelt front-end behaviours (mirrors Reveal.jsx, Header.jsx, ProductDetailPage.jsx) */
(function () {
  /* Reveal on scroll ---------------------------------------------------- */
  function reveal(root) {
    var nodes = (root || document).querySelectorAll('.bb-reveal:not(.is-visible)');
    if (!nodes.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window) || document.documentElement.classList.contains('shopify-design-mode')) {
      nodes.forEach(function (n) { n.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -60px 0px' });
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* Mobile nav ----------------------------------------------------------- */
  function mobileNav() {
    document.querySelectorAll('[data-bb-menu-toggle]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var nav = document.getElementById(btn.getAttribute('aria-controls'));
        if (!nav) return;
        var open = nav.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    document.querySelectorAll('.bb-mobile-nav a').forEach(function (a) {
      a.addEventListener('click', function () {
        var nav = a.closest('.bb-mobile-nav'); if (nav) nav.classList.remove('is-open');
      });
    });
  }

  /* Smooth anchor scroll (header offset) -------------------------------- */
  function anchors() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href*="#"]');
      if (!a) return;
      var url = new URL(a.href, location.href);
      if (url.pathname !== location.pathname || !url.hash) return;
      var target = document.querySelector(url.hash);
      if (!target) return;
      e.preventDefault();
      var header = document.querySelector('.bb-header');
      var offset = header ? header.offsetHeight + 8 : 0;
      var top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
      history.replaceState(null, '', url.hash);
    });
  }

  /* Product page --------------------------------------------------------- */
  function product(root) {
    (root || document).querySelectorAll('[data-bb-product]').forEach(function (el) {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';

      var variants = [];
      try { variants = JSON.parse(el.querySelector('[data-bb-variants]').textContent); } catch (e) {}
      var moneyFormat = el.dataset.moneyFormat || '${{amount}}';
      var slides = Array.prototype.slice.call(el.querySelectorAll('.bb-gallery__slide'));
      var thumbs = Array.prototype.slice.call(el.querySelectorAll('.bb-thumb'));
      var idx = 0;

      function money(cents) {
        var amount = (cents / 100).toFixed(2);
        if (moneyFormat.indexOf('{{amount_no_decimals}}') !== -1) amount = Math.round(cents / 100).toString();
        if (moneyFormat.indexOf('{{amount_with_comma_separator}}') !== -1) amount = amount.replace('.', ',');
        return moneyFormat.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount).replace(/<[^>]+>/g, '');
      }

      function show(i) {
        if (!slides.length) return;
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); });
      }

      el.querySelectorAll('[data-bb-prev]').forEach(function (b) { b.addEventListener('click', function () { show(idx - 1); }); });
      el.querySelectorAll('[data-bb-next]').forEach(function (b) { b.addEventListener('click', function () { show(idx + 1); }); });
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });

      /* variants */
      var buyEl = el.querySelector('[data-bb-buy]') || el;
      var T = buyEl.dataset;
      var idInputs = Array.prototype.slice.call(el.querySelectorAll('input[name="id"]'));
      var idInput = idInputs[0];
      var priceEl = el.querySelector('[data-bb-price]');
      var compareEl = el.querySelector('[data-bb-compare]');
      var compareOverride = parseInt((el.querySelector('[data-bb-compare-override]') || {}).getAttribute ? el.querySelector('[data-bb-compare-override]').getAttribute('data-bb-compare-override') : 0, 10) || 0;
      var stockEl = el.querySelector('[data-bb-stock]');
      var atcs = Array.prototype.slice.call(el.querySelectorAll('.bb-atc, .bb-link-btn'));
      var atc = atcs[0];
      var atcLabel = el.querySelector('[data-bb-atc-label]');
      var qtyInput = el.querySelector('.bb-qty__value') || el.querySelector('input[name="quantity"]');
      var qtyMirrors = Array.prototype.slice.call(el.querySelectorAll('[data-bb-qty-mirror]'));
      function syncQty() { qtyMirrors.forEach(function (m) { m.value = qtyInput ? qtyInput.value : 1; }); }

      function selectVariant(v, btn) {
        if (!v) return;
        idInputs.forEach(function (i) { i.value = v.id; });
        el.querySelectorAll('.bb-variant').forEach(function (b) { b.classList.toggle('is-selected', b === btn); });
        if (priceEl) priceEl.textContent = money(v.price);
        if (compareEl) {
          var cmp = (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : (compareOverride > v.price ? compareOverride : 0);
          if (cmp) { compareEl.textContent = money(cmp); compareEl.hidden = false; } else compareEl.hidden = true;
        }
        if (v.featured_media_position && slides.length) show(v.featured_media_position - 1);
        updateStock(v);
        try { history.replaceState(null, '', location.pathname + '?variant=' + v.id); } catch (e) {}
      }

      function updateStock(v) {
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        var managed = v.inventory_management === 'shopify' && v.inventory_policy === 'deny';
        var available = v.available;
        atcs.forEach(function (b) { b.disabled = !available; });
        if (atcLabel) atcLabel.textContent = available ? T.textAdd : T.textSoldOut;
        if (!stockEl) return;
        stockEl.hidden = true;
        if (!available) {
          stockEl.className = 'bb-stock bb-stock--none'; stockEl.querySelector('span').textContent = T.textUnavailable; stockEl.hidden = false;
        } else if (managed && v.inventory_quantity > 0) {
          if (qty > v.inventory_quantity) {
            stockEl.className = 'bb-stock bb-stock--low';
            stockEl.querySelector('span').textContent = T.textOnly.replace('[count]', v.inventory_quantity);
          } else {
            stockEl.className = 'bb-stock bb-stock--ok';
            stockEl.querySelector('span').textContent = T.textInStock.replace('[count]', v.inventory_quantity);
          }
          stockEl.hidden = false;
        }
      }

      el.querySelectorAll('.bb-variant').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = variants.find(function (x) { return String(x.id) === btn.dataset.variantId; });
          selectVariant(v, btn);
        });
      });

      /* quantity */
      el.querySelectorAll('[data-bb-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qtyInput) return;
          var n = (parseInt(qtyInput.value, 10) || 1) + parseInt(b.dataset.bbQty, 10);
          qtyInput.value = Math.max(1, n);
          syncQty();
          var current = variants.find(function (x) { return String(x.id) === (idInput && idInput.value); });
          if (current) updateStock(current);
        });
      });
      if (qtyInput) qtyInput.addEventListener('change', function () { if (parseInt(qtyInput.value, 10) < 1 || isNaN(parseInt(qtyInput.value, 10))) qtyInput.value = 1; syncQty(); });

      var initial = variants.find(function (x) { return String(x.id) === (idInput && idInput.value); });
      if (initial) updateStock(initial);
      show(0);
    });
  }

  function init(root) { reveal(root); mobileNav(); product(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); anchors(); });
  else { init(); anchors(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
